<blaze-dialog [showCloseButton]="false" [showFooter]="false" [scroll]="false">
  <button icon class="icon-back" blazeIconButton (click)="returnToBuilder()">
    <mat-icon svgIcon="icon_chevron_left_16" />
  </button>

  <div title> {{ action.data.httpMethod }} {{ action.data.name }} / Response schema </div>

  <ng-container actions>
    <button blazeIconButton (click)="returnToBuilder()">
      <mat-icon svgIcon="icon_close_16" />
    </button>
  </ng-container>

  <div content class="content-wrapper">
    <blaze-scroller class="content-scroller">
      <blaze-tree-select class="tree-select" [data$]="data$" />
    </blaze-scroller>
  </div>
</blaze-dialog>
